import { render } from "./GifChoice.vue?vue&type=template&id=2663c9b6"
import script from "./GifChoice.vue?vue&type=script&lang=js"
export * from "./GifChoice.vue?vue&type=script&lang=js"

import "./GifChoice.vue?vue&type=style&index=0&id=2663c9b6&lang=scss"
script.render = render

export default script